<template>
  <div class="form-health">
    <p class="text large sybold">基本健康信息</p>
    <p class="text mt-30">
      出于对每个学生健康状况的关心和负责，我们要求你如实且完整地填写以下健康问卷。你填写的信息按照分级程度将被上报给你在峰会期间的负责老师和主办学校，并用于现场的管理和照顾。同时峰会组委会将为每一位录取的学生购买意外伤害险，因此需要学生提供必要的信息。
    </p>
    <p class="text mt-10">
      健康信息本身不会影响你的峰会录取资格，但由于峰会活动在公立学校内部举办，医疗条件和应急预案完全按照学校日常的标准实施，无法满足学生部分特殊的医疗需求，你在同意出席时，即需要了解并认可这些软硬件限制。如在活动进行中我们认为你在生理或心理健康上暂时不适宜继续参加峰会活动的，我们有权联系你的监护人或紧急联系人，单独安排活动甚至延后本次活动资格，等到身体状况恢复后，再来参加。如果发生故意隐瞒健康状况，由此造成的一切后果，将由你和监护人共同承担，组委会也将视情形的严重程度决定是否取消学生未来参加其他哈佛在华青少年系列活动的资格。
    </p>
    <p class="text mt-10 sybold">
      当你提交本健康信息登记表就视为你已经完全阅读、知悉并同意本表中全部内容。如果本表中的内容在峰会之前发生任何变化，请再次填写本表，更新相应信息。
    </p>
    <p class="text sybold mt-30">学生在峰会期间是否需要使用特殊药物？</p>
    <RadioGroupPropotype className="radio-group-wrap mt-20" :options="QUESTIONS.MEDICINE_OPTIONS" v-model="form.q1" />
    <div v-show="isShowQ1Complete">
      <p class="text sybold mt-30">请具体描述药物名称、用药频率和注意事项</p>
      <div class="flex-line mt-10 long">
        <TextareaPrototype :counter="false" placeholder="" v-model="form.q1_complete" />
      </div>
    </div>
    <p class="text sybold mt-30">你是否在过去的12个月里出现过以下症状或行为？</p>
    <CheckboxGroupPrototype className="radio-group-wrap mt-20" :options="QUESTIONS.SYMPTOM_OPTIONS" v-model="form.q2" />
    <p class="text sybold mt-30">你是否在过去的12个月里接受过如下治疗？</p>
    <CheckboxGroupPrototype className="radio-group-wrap mt-20" :options="QUESTIONS.CURE_WAYS_OPTIONS" v-model="form.q3" />
    <p class="text sybold mt-30">你是否在过去的12个月里接受过如下治疗？</p>
    <CheckboxGroupPrototype className="radio-group-wrap mt-20 no-flex" :options="QUESTIONS.CURE_DISEASE_OPTIONS" v-model="form.q4" />
    <p class="text sybold mt-30">
      任何问题选是，请详细说明具体的疾病情况、时间和严重程度。如上述问题无法涵盖你的情况，请你具体描述其他我们需要知晓的情况（如无，请填写无）
    </p>
    <div class="flex-line mt-10 long">
      <TextareaPrototype :counter="false" placeholder="" v-model="form.q5" />
    </div>
    <p class="text sybold mt-20">
      如果因为宗教、身体健康等原因，你有任何饮食上的特殊要求，请具体说明情况进行告知，主办学校食堂会参照日常学校操作标准，尽力进行准备（如无，请填写无）
    </p>
    <div class="flex-line mt-10 long">
      <TextareaPrototype :counter="false" placeholder="" v-model="form.q6" />
    </div>
    <!-- <p class="text sybold mt-20 red">
      今年峰会将在线下进行，所有参与者将前往峰会现场，入住校园。距离峰会开始还有一个多月，我们提倡国内学生原则上不出境、不去国内中高风险地区，峰会开始前14天开展自我健康管理。
    </p>
    <p class="text sybold mt-20 red">
      另外，根据相关防疫隔离政策，组委会要求海外参与者不晚于7月11日入境中国。请海外参与者留好入境记录，我们会在临近峰会开始前收集入境记录。
    </p> -->
    <Button class="btn-submit mt-30" @click="handleClickSubmit">提交</Button>
  </div>
</template>
<script>
import FORM from './form';
import QUESTIONS from './questions';
import { Api, Codes } from 'api';
import { CheckboxGroupPrototype, RadioGroupPropotype, TextareaPrototype, Button } from 'components/form';
const ERR_MSG = {
  EMPTY: '请完善信息后再提交！'
};
export default {
  name: 'Health',
  components: {
    CheckboxGroupPrototype,
    RadioGroupPropotype,
    Button,
    TextareaPrototype
  },
  data: () => ({
    form: {}
  }),
  computed: {
    QUESTIONS() {
      return QUESTIONS;
    },
    isShowQ1Complete() {
      return this.form?.q1?.find(item => item.value === '是');
    }
  },
  async created() {
    this.$loading.show();
    let res = await Api.get.getStudentCompleteInfo();
    let extendData = {};
    if (res.status === Codes.SUCCESS) {
      extendData = {
        ...res.data?.health,
        q1: res.data?.health?.q1 ? [{ value: res.data?.health?.q1 }] : [],
        q2: res.data?.health?.q2 ? res.data.health.q2.map(item => ({ value: item })) : [],
        q3: res.data?.health?.q3 ? res.data.health.q3.map(item => ({ value: item })) : [],
        q4: res.data?.health?.q4 ? res.data.health.q4.map(item => ({ value: item })) : []
      };
    }
    this.form = {
      ...FORM,
      ...extendData
    };
    this.$loading.hide();
  },
  methods: {
    getAnswer(key) {
      let ret = '';
      switch (key) {
        case 'q1': {
          let q1 = this.form.q1;
          if (q1.length) {
            ret = q1[0].value;
          }
          break;
        }
        default: {
          let q = this.form[key];
          if (q.length) {
            ret = [];
            q.forEach(item => {
              ret.push(item.value);
            });
          }
          break;
        }
      }
      return ret;
    },
    checkFormData() {
      let ret = {
        legal: true,
        msg: ''
      };
      if (this.isShowQ1Complete && !this.form.q1_complete) {
        ret.legal = false;
        ret.msg = ERR_MSG.EMPTY;
      } else {
        let keys = Object.getOwnPropertyNames(this.form).filter(item => /^q\d$/.test(item));
        keys.forEach(key => {
          let item = this.form[key];
          if (!item || !item.length) {
            ret.legal = false;
            ret.msg = ERR_MSG.EMPTY;
          }
        });
      }
      if (!ret.legal) {
        this.$message.error(ret.msg);
      }
      return ret.legal;
    },
    async handleClickSubmit() {
      this.$loading.show();
      if (this.checkFormData()) {
        let res = await Api.post.postStudentCompleteHealth({
          ...this.form,
          q1: this.getAnswer('q1'),
          q2: this.getAnswer('q2'),
          q3: this.getAnswer('q3'),
          q4: this.getAnswer('q4')
        });
        if (res.status === Codes.SUCCESS) {
          this.$message.success('保存成功！');
          this.$router.push({
            name: 'pay-admission-success'
          });
        } else {
          this.$message.error(res.msg);
        }
      }
      this.$loading.hide();
    }
  }
};
</script>
